import React from 'react'
import { BiHomeAlt } from 'react-icons/bi'
import { IoMdSettings } from 'react-icons/io'
import { CgWorkAlt } from 'react-icons/cg'
import { RiQuestionLine } from 'react-icons/ri'
import { GiTreeBranch } from 'react-icons/gi'
import { HomeIcon } from './asset/Home'
import { SavingsIcon } from './asset/Savings'
import { InvestIcon } from './asset/invest'
import { SettingsIcon } from './asset/Settings'
import { FaqIcon } from './asset/Faq'

export const SidebarData = [
  {
    title: 'Home',
    path: '/homepage',
    icon: <HomeIcon stroke="currentColor" />,
    cName: 'nav-text',
  },
  {
    title: 'Savings',
    path: '/savings',
    icon: <SavingsIcon stroke="currentColor" />,
    cName: 'nav-text',
  },
  {
    title: 'Invest',
    path: '/invest',
    icon: <InvestIcon stroke="currentColor" />,
    cName: 'nav-text',
  },
  // {
  //   title: 'Collabo',
  //   path: '/collabo',
  //   icon: <GiShakingHands className="icons"/>,
  //   cName: 'nav-text'
  // },
  {
    title: 'X-contest',
    path: '/x-contest',
    icon: <GiTreeBranch className="icons" />,
    cName: 'nav-text',
  },
  // {
  //   title: 'FAQs',
  //   path: '/faqs',
  //   icon: <FaqIcon stroke="currentColor" />,
  //   cName: 'nav-text',
  // },
  {
    title: 'Settings',
    path: '/settings',
    icon: <SettingsIcon stroke="currentColor" />,
    cName: 'nav-text',
  },
]
